import { type TCollection as TApiCollection } from '@core/api'

import { type TCollection } from '@core/models'

import { convertAudioSimple } from './convertAudioSimple'
import { convertCollectionSimple } from './convertCollectionSimple'

export const convertCollection = (apiCollection: TApiCollection): TCollection => {
    const { items, ...restProps } = apiCollection

    return {
        ...convertCollectionSimple({
            ...restProps,
            items_count: apiCollection.items_count ?? items?.length ?? 0,
        }),
        items: items?.map(convertAudioSimple) ?? [],
    }
}
